<template>
  <path id="ic_play_arrow_24px" d="M8,5V41.908L37,23.454Z" transform="translate(-8 -5)" />
</template>
